import { useTranslation, Trans } from 'react-i18next';

const Feature = ({ icon, label }) => (
  <div className="gp-feature">
    <span className="gp-feature__icon" aria-hidden>{icon}</span>
    <span className="gp-feature__label">{label}</span>
  </div>
);

const PitchSection = () => {
  const { t } = useTranslation();
  return (
    <div className="gp-pitch">
      <h2 className="gp-pitch__heading">
        <Trans i18nKey="open.preview.pitch.heading" components={{ em: <em /> }} />
      </h2>
      <p className="gp-pitch__sub">{t('open.preview.pitch.subtitle')}</p>
      <div className="gp-pitch__features">
        <Feature icon="🗺️" label={t('open.preview.pitch.feature1')} />
        <Feature icon="👥" label={t('open.preview.pitch.feature2')} />
        <Feature icon="🏆" label={t('open.preview.pitch.feature3')} />
      </div>
    </div>
  );
};

export default PitchSection;
